import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {useStyles} from '../style';
import {Stack} from '@mui/material';
import {strings} from '@app/common/strings';

const OrderFormHeading = ({handleToggleModal, title}: any) => {
  const classes = useStyles();
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      className={classes.RfHeadingContainer}>
      <Typography
        sx={{margin: '0px !important'}}
        className={classes.RfHeading}
        fontSize="18.7px"
        fontWeight="600"
        color="#1c1939"
        variant="h6">
        {title}
      </Typography>
      <IconButton
        data-testid="close-modal"
        sx={{padding: '0px'}}
        onClick={() => handleToggleModal('review')}
        color="primary">
        <CloseIcon sx={{marginRight: '-6px'}} fontSize="large" />
      </IconButton>
    </Stack>
  );
};

export default OrderFormHeading;
